import { Card, IconButton, Paper, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, tableCellClasses } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { Button, CardBody, CardHeader, Spinner, Table } from 'reactstrap';
import { styled } from '@mui/material/styles';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import FeedIcon from '@mui/icons-material/Feed';
import AlertService from '../../../services/AlertService';
import CertificadoService from '../../../services/CertificadoService';
import { CasUserContext, useCasUserContext } from '../../../services/casUserContext';
import { useNavigate } from 'react-router-dom';
import UsuarioService from '../../../services/UsuarioService';
import { Categoria, DataSistema } from '../../../interfaces/Sistema';
import CatalogService from '../../../services/CatalogService';
import { ModalEditarCategoria } from './ModalEditarCategoria';
const alertaService = new AlertService;
const certificadoService = new CertificadoService;
const usuarioservice = new UsuarioService;
const catalogoService = new CatalogService();

interface Column {
    id: 'numero'|'nombre'|'activo'|'opciones';
    label: string;
    minWidth?: number;
    align?: 'center';
    format?: (value: number) => string;
    
  }

  const columns: readonly Column[] = [
    { 
        id: 'numero', 
        label: '#', 
     },
     {
        id: 'nombre',
        label: 'Nombre',
    },
    {
        id: 'activo',
        label: 'Activo',
    },
    {
        id: 'opciones',
        label: 'Opciones',
    }
  ];

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
    border: 0,
    },
}));

export default function TablaCategoriaProductos(props: DataSistema){
    const [rowsPerPage, setRowsPerPage] = useState(props.rowsPerPage[0]);
    const [page, setPage] = useState(0);
    const [categoriasTodas,setCategoriasTodas] = useState<Array<Categoria>>([]);
    //const casUserContext = useContext(CasUserContext);
    const casUserContext = useCasUserContext();
    const [openEditar, setOpenEditar] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');
    let [dataEditar, setDataEditar]=useState<number>(0);

    const abrirModalEditar=(data: number) =>{
        setOpenEditar(true)
        setDataEditar(data);
    }

    const cerrarModal=()=>{
        //setOpen(false)
        setOpenEditar(false)
    }

    const constFilteredCert = categoriasTodas.filter((categoria) => {
        if (categoria.nombrecategoria.toUpperCase().includes( globalFilter.toUpperCase()) ) {
            return true;
        }
            return false;
    });


    const token = casUserContext.token;

    const fetchData = async () =>{
        try{
             alertaService.showLoading("Cargando Datos..."); 
             await catalogoService.GetCategoriasTodas() 
             .then((data)=>{
                if(data.status.isSuccessfully){
                    setCategoriasTodas(data.listData.reverse())
                }
             }) 
             .catch((error) => console.error(error));               
             alertaService.hideLoading();                
        }catch(error){
          console.error('Error:',error);
        }
      };

    useEffect(() => {
        fetchData();
        },[token]);
    
    //  useEffect(() => {
    //     fetchData();
    //  },[token]);

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    return(
        
        
        <Card>
            <ModalEditarCategoria isOpen={openEditar} toggle={cerrarModal} data={dataEditar} />
            <CardBody>
                <div >
                    <div className='my-2 text-right'>
                        <input type="text" className='p-2 text-gray-600 border border-gray-300 rounded outline-indigo-700' placeholder='Buscar...' 
                             onChange={e=>setGlobalFilter(e.target.value)}
                        />
                    </div>
                </div>
            <TableContainer sx={{ maxHeight: 600 }}>
            <Table stickyheader="true" aria-label="sticky table" >
                <TableHead>
                <TableRow>
                {columns.map((column) => (                
                    <StyledTableCell 
                            style={{ minWidth: column.minWidth }}
                            key={column.id}
                            align={column.align}>
                        {column.label}
                        </StyledTableCell>
                    ))}
                </TableRow>
                </TableHead>
                <TableBody>
                    
                    {
                        constFilteredCert.length>0 ? constFilteredCert
                        .slice(page * rowsPerPage, page*rowsPerPage+rowsPerPage)
                        .map((row, index)=>{
                            return(
                                <StyledTableRow key={index}>
                                    <StyledTableCell align="center">{row.ncategoria}</StyledTableCell>
                                    <StyledTableCell align="center">{row.nombrecategoria}</StyledTableCell>  
                                    <StyledTableCell align="center">{row.activo==1 ? 'Si' : 'No'}</StyledTableCell> 
                                    <StyledTableCell align="center">
                                        <IconButton color='primary' component="span" onClick={()=>abrirModalEditar(row.iddecinvcategoria)}>
                                            <EditIcon />
                                        </IconButton>
                                    </StyledTableCell> 
                                </StyledTableRow>
                            )
                        })
                        :
                        <StyledTableRow key={0}>
                            <StyledTableCell align="center"></StyledTableCell>
                            <StyledTableCell align="center">No hay datos para presentar</StyledTableCell>  
                            <StyledTableCell align="center"></StyledTableCell> 
                            <StyledTableCell align="center"></StyledTableCell> 
                        </StyledTableRow>
                    }
                {/* {constFilteredCert.length > 0 ? constFilteredCert
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row,index) => {
                    return (
                        
                        <StyledTableRow key={index}>
                            <ModalDetalleUsuario isOpen={open} toggle={cerrarModal} data={dataUsuario} />
                            
                            <StyledTableCell align="left">{row.identificacion}</StyledTableCell>
                            <StyledTableCell align="left"> {row.usuario} </StyledTableCell>
                            <StyledTableCell align="left"> {row.nombres} </StyledTableCell>
                            <StyledTableCell align="left"> {row.rolprincipal} </StyledTableCell>
                            <StyledTableCell align="left"> {
                                row.rolessecundarios.length>0 ? row.rolessecundarios.map((row,index)=>{
                                    return(
                                        <li key={index} >{row.rol}</li>
                                    )
                                }):<span></span>
                            }
                            </StyledTableCell>
                            <StyledTableCell align="left"> {row.unidad} </StyledTableCell>
                            <StyledTableCell align="left"> {row.autorizado} </StyledTableCell>
                            <StyledTableCell align="left"> {row.orcid} </StyledTableCell>
                            <StyledTableCell align="left"> {row.scholarid} </StyledTableCell>
                            <StyledTableCell align="left"> {row.scopusid} </StyledTableCell>
                            <StyledTableCell align="center">
                                <IconButton color='primary' onClick={()=>abrirModalEditar(row.iddecinvuser)} component="span">
                                    <EditIcon />
                                </IconButton>
                                <IconButton color='primary' onClick ={()=>abrirModal(row)} component = "span">
                                    <FeedIcon />
                                </IconButton>
                                <IconButton color='primary' onClick={()=>mostrarEliminar('Eliminar usuario','Está seguro que desea eliminar al usuario: '+row.usuario,row.iddecinvuser)} component = "span">
                                    <DeleteIcon />
                                </IconButton>
                            </StyledTableCell>
                        </StyledTableRow>
                        );
                    }):
                    <StyledTableRow key={0}>
                        <StyledTableCell align="center">No se encontraron certificados</StyledTableCell>
                        <StyledTableCell align="center"></StyledTableCell>  
                        <StyledTableCell align="center"></StyledTableCell> 
                        <StyledTableCell align="center"></StyledTableCell> 
                        <StyledTableCell align="center"></StyledTableCell> 
                        <StyledTableCell align="center"></StyledTableCell> 
                        <StyledTableCell align="center"></StyledTableCell> 
                        <StyledTableCell align="center"></StyledTableCell> 
                        <StyledTableCell align="center"></StyledTableCell> 
                        <StyledTableCell align="center"></StyledTableCell> 
                        <StyledTableCell align="center"></StyledTableCell> 
                    </StyledTableRow>
                    } */}
                    
                </TableBody>
            </Table>
            </TableContainer>
            <TablePagination
            rowsPerPageOptions={props.rowsPerPage}
            component="div"
            count={constFilteredCert.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            />
            </CardBody>
        </Card>      
    )

}